import React from "react";

import SectionFeatures from "components/SectionFeatures";
import SectionBlogSuggestions from "components/SectionBlogSuggestions";
import SectionTestimonials from "components/SectionTestimonials";
import SectionLogoRow from "components/SectionLogoRow";
import SectionClientCases from "components/SectionClientCases";
import SectionCTA from "components/SectionCTA";
import SectionContent, { SectionHero } from "components/SectionContent";
import SectionLeadership from "components/SectionLeadership";
import SectionCollapsible from "components/SectionCollapsible";
import SectionContentCards from "components/SectionContentCards";
import SectionEbooks from "components/SectionEbooks";
import SectionPricingCards from "components/SectionPricingCards";
import SectionPricingFeatureTable from "components/SectionPricingFeatureTable";

import { SECTION_TYPES } from "shared/constants";

const componentsMap = {
  [SECTION_TYPES.FEATURES]: SectionFeatures,
  [SECTION_TYPES.BLOG_SUGGESTIONS]: SectionBlogSuggestions,
  [SECTION_TYPES.CLIENT_CASES]: SectionClientCases,
  [SECTION_TYPES.TESTIMONIALS]: SectionTestimonials,
  [SECTION_TYPES.LOGO_ROW]: SectionLogoRow,
  [SECTION_TYPES.CALL_TO_ACTION]: SectionCTA,
  [SECTION_TYPES.CONTENT]: SectionContent,
  [SECTION_TYPES.HERO]: SectionHero,
  [SECTION_TYPES.LEADERSHIP]: SectionLeadership,
  [SECTION_TYPES.COLLAPSIBLE]: SectionCollapsible,
  [SECTION_TYPES.CONTENT_CARDS]: SectionContentCards,
  [SECTION_TYPES.EBOOKS]: SectionEbooks,
  [SECTION_TYPES.PRICING_CARDS]: SectionPricingCards,
  [SECTION_TYPES.PRICING_FEATURE_TABLES]: SectionPricingFeatureTable,
};

/**
 * @typedef {object} SectionsPageTemplateProps
 * @prop {GatsbyTypes.SectionDataFragment[]} sections
 *
 * @param {SectionsPageTemplateProps} props
 */

export function SectionsPageTemplate({ sections }) {
  return (
    <React.Fragment>
      {sections.map((section, section_idx) => {
        const Component = componentsMap[section.type];
        if (!Component) return null;
        return <Component key={section_idx} {...section} />;
      })}
    </React.Fragment>
  );
}
